import React from 'react'
import BookOnlineIcon from '@mui/icons-material/BookOnline'
import EditIcon from '@mui/icons-material/Edit'
import ShieldOutlinedIcon from '@mui/icons-material/ShieldOutlined'
import { List, ListItem, ListItemText, Theme, Button } from '@mui/material'
import { Profile } from '../../Profile/types'

interface Props {
  isMultiFactorEnabled: boolean
  profile: Profile
  onOpenMultiFactorModal: () => void
  onOpenProfileModal: () => void
  onOpenUnitsModal: () => void
}

const LIST_ITEM_SX = {
  paddingTop: 0,
  paddingBottom: 0,
  marginBottom: 0,
}

const LIST_ITEM_TEXT_SX = {
  '& 	.MuiListItemText-secondary': {
    fontSize: 'x-small',
    textTransform: 'uppercase',
    color: (theme: Theme) => theme.palette.grey[700],
  },
  marginBottom: '2px',
  marginTop: '2px',
  minHeight: '36px',
}

export const PortalListComponent: React.FC<Props> = ({
  isMultiFactorEnabled,
  profile: {
    fullName,
    address,
    city,
    state,
    zip,
    email,
    phoneNumber,
    cardNumber,
  },
  onOpenMultiFactorModal,
  onOpenProfileModal,
  onOpenUnitsModal,
}) => (
  <List dense sx={{ width: '100%' }}>
    <ListItem sx={LIST_ITEM_SX}>
      <Button
        variant="contained"
        color="info"
        startIcon={<BookOnlineIcon />}
        fullWidth
        onClick={onOpenUnitsModal}
      >
        Reserve Units
      </Button>
    </ListItem>
    <ListItem sx={{ ...LIST_ITEM_SX, marginTop: '10px' }}>
      <ListItemText
        primary={fullName}
        secondary="name"
        sx={LIST_ITEM_TEXT_SX}
      />
    </ListItem>
    <ListItem sx={LIST_ITEM_SX}>
      <ListItemText
        primary={address ? `${address}, ${city}, ${state} ${zip}` : ''}
        secondary="address"
        sx={LIST_ITEM_TEXT_SX}
      />
    </ListItem>
    <ListItem sx={LIST_ITEM_SX}>
      <ListItemText primary={email} secondary="email" sx={LIST_ITEM_TEXT_SX} />
    </ListItem>
    <ListItem sx={LIST_ITEM_SX}>
      <ListItemText
        primary={phoneNumber}
        secondary="phone number"
        sx={LIST_ITEM_TEXT_SX}
      />
    </ListItem>
    <ListItem sx={{ ...LIST_ITEM_SX, marginBottom: '10px' }}>
      <ListItemText
        primary={cardNumber}
        secondary="cc on file"
        sx={LIST_ITEM_TEXT_SX}
      />
    </ListItem>
    <ListItem sx={LIST_ITEM_SX}>
      <ListItemText
        primary={isMultiFactorEnabled ? 'Enabled' : 'Not enabled'}
        secondary="two-step verification"
        sx={LIST_ITEM_TEXT_SX}
      />
    </ListItem>
    <ListItem>
      <Button
        variant="contained"
        color="warning"
        startIcon={<EditIcon />}
        fullWidth
        onClick={onOpenProfileModal}
      >
        Update Profile
      </Button>
    </ListItem>
    <ListItem sx={{ pt: 1 }}>
      <Button
        variant="outlined"
        color={isMultiFactorEnabled ? 'success' : 'secondary'}
        startIcon={<ShieldOutlinedIcon />}
        fullWidth
        onClick={onOpenMultiFactorModal}
      >
        {isMultiFactorEnabled
          ? 'Manage Two-Step Verification'
          : 'Set Up Two-Step Verification'}
      </Button>
    </ListItem>
  </List>
)
